import type { ComponentType } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { LinkProps } from '@mui/material/Link';
import { useCurrentUser } from '~/shared/hooks/useCurrentUser';
import { UserRole } from '~/shared/types';

const NAV_LINKS: { to: string; label: string }[] = [
  { to: '/matters', label: 'Matters' },
  { to: '/profile', label: 'Profile' },
  { to: '/home', label: 'Home' },
];

const Navigation = () => {
  const { user: currentUser } = useCurrentUser();

  if (!currentUser) {
    return null;
  }

  if (!NAV_LINKS.length) {
    return null;
  }

  let profileTo = '/matters';
  if (currentUser.role === UserRole.EXPERT) {
    profileTo = `/experts/${currentUser.id}`;
  } else if (currentUser.role === UserRole.ATTORNEY) {
    profileTo = `/attorneys/${currentUser.id}`;
  }

  const links = NAV_LINKS.map(({ to, label }) => ({
    to: label === 'Profile' ? profileTo : to,
    label,
  }));

  return (
    <Stack
      component="nav"
      direction="row"
      spacing={2}
      aria-label="Main navigation"
    >
      {links.map(({ to, label }) => (
        <NavLink
          key={`${to}-${label}`}
          component={RouterLink}
          to={to}
          underline="hover"
        >
          {label}
        </NavLink>
      ))}
    </Stack>
  );
};

const NavLink = styled(Link)(() => ({
  color: 'inherit',
})) as ComponentType<LinkProps<typeof RouterLink>>;

export default Navigation;
